import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from '../../user.service';
import { User } from '../../../../models/user.model';
import { globalConst } from '../../../../helpers/constants';
import { Helper } from 'src/app/shared/helpers/helper';
import { Alert } from 'src/app/shared/class/Alert';

@Component({
  selector: 'app-user-search',
  templateUrl: './user-search.component.html',
  styleUrls: ['./user-search.component.scss']
})

export class UserSearchComponent implements OnInit, OnDestroy {
  goback = '';
  subscription = new Subscription();
  itemsPerPage = 5;
  currentPage = 1;
  users: User[] = [];
  optionsUserType = globalConst.options.userTypes;
  filters = {
    userType: 0,
    userName: ''
  };

  constructor(
    private userService: UserService,
    private spinner: NgxSpinnerService
  ) {

  }

  ngOnInit() { }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getUsers() {
    const params = `${this.filters.userType}/${this.filters.userName}`;
    this.users = [];
    this.spinner.show();
    this.subscription.add(
      this.userService.getUsers(params).subscribe(
        (data: User[]) => {
          this.users = data;
          this.spinner.hide();
        },
        error => {
          this.spinner.hide();
          Alert.warning(Alert.getMessage().errors.emptySearch).then(() => Helper.handleError);
        }
      )
    );
  }

}
